import React, { Component } from "react";
import { Route, withRouter, Switch } from "react-router-dom";
// import PropTypes from "prop-types";
// import Cookies from "js-cookie";
import { Helmet } from 'react-helmet';
import routes from "./routes";
import "./App.css";
import "./Font.css";
import Header from './header/Header';
import Footer from './footer/Footer';
import TagManager from 'react-gtm-module';
const tagManagerArgs = {
  gtmId: 'GTM-TRLFM96'
}

// Route.propTypes = {
//   computedMatch: PropTypes.object,
//   path: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
//   exact: PropTypes.bool,
//   strict: PropTypes.bool,
//   sensitive: PropTypes.bool,
//   component: PropTypes.func,
//   render: PropTypes.func,
//   children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
//   location: PropTypes.object
// }

// global.api_ci_url = "http://localhost/parenting/";
global.hosturl = "https://parenting.firstcry.ae/";
 //global.hosturl="http://localp.firstcry.ae/";
// global.api_ci_url = "https://stageparenting.firstcry.com/parenting/";
// global.api_url = "http://3.6.249.19/";
// global.fcapi_url = "http://stage.firstcry.com/svcs/MyAccountService.svc/";
 //global.api_ci_url = "http://localp.firstcry.ae/parenting/";
global.api_ci_url = "https://parenting.firstcry.ae/parenting/";
// global.api_url = "http://155.55.34.70/";
global.api_url = "http://community.ae1stcry.com/";
// global.api_url = "http://3.6.249.19/";
global.fcapi_url = "http://www.firstcry.com/svcs/MyAccountService.svc/";
global.redirect_url = "https://parenting.firstcry.ae/";
// global.loginUrl = 'https://www.firstcry.com/m/login';
// global.registerUrl = 'https://www.firstcry.com/m/register';
global.loginUrl = 'https://parenting.firstcry.ae/login-register/signin';
global.registerUrl = 'https://parenting.firstcry.ae/login-register/';
global.logoutUrl = "https://parenting.firstcry.ae/login-register/logout";
global.accessToken = "";
global.ftk = "";
global.uID = "";
global.clientId = "";
global.userAgent = 'Unidentified User Agent';
global.isdesktop = true;
global.currentURL = "";
global.userAry = {};
// Cookies.set("FC_AUTH", '2310408a63388fe57e3a4177168a87989cZ0pJjeb/ktThXsMFPt4C7hA3SpCoERAC7pZD483JPpEYSbsPN980cFN8lFmGIQ36HA2Il+nSZ1J+vG8WTIVuVPWK5WKiTlKbU5jCV+IM+483Zd/FhlUB50CU0SnnVQPxOv1a/DeWykC35EhCfwq6kbCl1kh6WzgMoIaXoU4xr2UiQ/c+e8eW2cj8mtB0KB5ATBXnXjzDkaX6cDZnB3Kl4q+VDpwuYOkWPQVmZTZAEt8mXKhwkQbOEG9PENBjzbyZoi6G4Nj2Gkz8+8GKIb9ed2IJsYdXFjy8eY81DHtC/Me+jr/+Nrw9Y6Csm76WhQpaua+osfc5Hbu1eLFTu1CMRrU0a2m7xRcw3ZcWIDn0MkM9Qknd3BSswwIOBlFYhaKF/VsI/2r9U05nsp4kYbZsb/LL2jp/jCh1ghd1SQCbKx908tw1JphlidkvIVZP7Bm8EUhlbWrXyRCDqtwncJe1IWQthVWm56hU8XW4U5Lye5/3OFnMRQ2CYJNa/vT7K6wOudR/XH5+C2PlgydynufF0ZqoDIrH7YzCUHity7VECE3ZpJL3Qa1nrsXgmTFej4tKXxnJ/byjHQxN7SpoIeYg==');

class App extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    TagManager.initialize(tagManagerArgs);
    // global.currentURL = window.location.href;
    if (navigator.userAgent) {
      global.userAgent = navigator.userAgent;
    }
    if (navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      global.isdesktop = false;
    }
  }

  render() {
    var canonical_url = this.props.location;
    canonical_url = canonical_url.replace("http://", "https://").split('?')[0];
    var linkAry = [];
    var MetaInfo = [];
    canonical_url = canonical_url.replace("http://", "https://").split('?')[0];
    if (this.props.location.includes("/baby-names")) {  
        canonical_url = canonical_url.replace(/\/?$/, '/');
        MetaInfo = [
          { "name" : "robots", "content" : "noindex"}
        ]     
    } 
    if (this.props.location.includes("baby-names") && !this.props.location.includes("/amp/")) {
      var _canonical_url = canonical_url.toLowerCase();
      var amphtml_url = _canonical_url + 'amp/';
      if(_canonical_url.charAt(_canonical_url.length-1) != '/'){
        amphtml_url = _canonical_url + '/amp/';
      }
      linkAry = [
        { "rel": "canonical", "href": _canonical_url },
        { "rel": "amphtml", "href": amphtml_url }
      ]
    }else {
      linkAry = [
        { "rel": "canonical", "href": canonical_url },
        { "rel": "alternate", "href": canonical_url.replace('.firstcry.com','.firstcry.ae'), "hreflang":"en" },
        { "rel": "alternate", "href": canonical_url, "hreflang":"en-ae" },
      ];
    }
    return (
      <div>
        <Helmet
          link={linkAry}
        />
        <Route component={withRouter(Header)} />
        <Switch>
          {/* <Route
            path="/qna/questions-answers/page/:page"
            exact={true}
            render={() => {
              return (
                <Redirect to="/qna/questions-answers" state={{ status: 301 }} />
              )
            }}
          /> */}
          {routes.map((route, i) => <Route key={i} {...route} />)}
        </Switch>
        <Route component={withRouter(Footer)} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// src/shared/App.js